import { HttpService } from '@core/services/http.service.ts';
import { apiURL } from '@utils/environment.ts';
import { UserNotification } from '@core/modeles/Notifimodels.ts';

export class NotificationService extends HttpService {
  private APIURL = apiURL;

  getAllNotifications(): Promise<UserNotification[]> {
    this.urlAPI = `${this.APIURL}/notification`;
    return this.doGet<UserNotification[]>();
  }

  markAsRead(notificationId: number): Promise<void> {
    this.urlAPI = `${this.APIURL}/notification/${notificationId}/mark-as-read`;
    return this.doPut<void, any>({});
  }

  markAsUnread(notificationId: number): Promise<void> {
    this.urlAPI = `${this.APIURL}/notification/${notificationId}/mark-as-unread`;
    return this.doPut<void, any>({});
  }

  markAllAsRead(): Promise<void> {
    this.urlAPI = `${this.APIURL}/notification/mark-all-as-read`;
    return this.doPut<void, any>({});
  }
}